module.exports = __webpack_public_path__ + "img/tnb-logo-report.73b97997.png";